import { render, staticRenderFns } from "./ActionPostbackReminder.vue?vue&type=template&id=0bfaf1ca&"
import script from "./ActionPostbackReminder.vue?vue&type=script&lang=js&"
export * from "./ActionPostbackReminder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports